import googleAnalyticsReporter from '@cdo/apps/lib/util/GoogleAnalyticsReporter';

googleAnalyticsReporter.sendPageView();
